module.exports = __webpack_public_path__ + "5a9a0c818fbe3b679319c402354f7a65.png";